var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHome = function SvgHome(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16,
    height: 16,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m13.355 7.147-1-1-4-4a.5.5 0 0 0-.708 0l-4 4-1 1a.5.5 0 0 0 .707.707l.147-.147V12.5a.5.5 0 0 0 .5.5h8a.5.5 0 0 0 .5-.5V7.707l.147.147a.5.5 0 0 0 .707-.707M11.5 12h-7V6.707l3.5-3.5 3.5 3.5z"
  })));
};
export { SvgHome as ReactComponent };
export default __webpack_public_path__ + "160344472ddc212e1a39e5dd7a6473b2.svg";